import { render, staticRenderFns } from "./ReArrange.vue?vue&type=template&id=1f9ea60c&scoped=true&"
import script from "./ReArrange.vue?vue&type=script&lang=js&"
export * from "./ReArrange.vue?vue&type=script&lang=js&"
import style0 from "./ReArrange.vue?vue&type=style&index=0&id=1f9ea60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ea60c",
  null
  
)

export default component.exports